import { ProductDataType } from '../model';

export type BundleData = ProductDataType & {
  readonly bundleName: string;
  readonly edition: string;
};

export type AvailableProductsSite = {
  readonly adminAccess: boolean;
  readonly cloudId: string;
  readonly products: string[];
  readonly url: string;
  readonly displayName: string;
  readonly avatarUrl?: string;
  readonly isVertigo?: boolean;
};

// to get status code from stargate error
export type ResponseError = Error & {
  response: Response;
};

// to check if response is available in error
export function isResponseError(error: unknown): error is ResponseError {
  return (
    error instanceof Error &&
    typeof (error as ResponseError).response === 'object'
  );
}
